import React, { Component } from 'react';
import { FormGroup, ControlLabel, FormControl} from 'react-bootstrap';
import { CCOAlert, FieldGroup, Select } from '../util/Components.js';
import Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import {clone, parseVerse, verseHash} from '../util/Utility.js';
import PanelEditView from '../model/PanelEditView.js';
import VerseGroup from '../util/VerseGroup.js';

const knownTeachers = ["Will Ramirez", "Jeremy Morse", "Tom Harper", "Greg Breznik", "Justin Reyes", "Mike Avila", "Fred Klesper", "Guest Speaker"];

export default class EditSermonView extends Component {

  constructor(props) {
    super(props);

    this.defaultObject = {
      teacher: "Will Ramirez",
      title: "",
      vimeoID: "",
      audioURL: "",
      date: moment().unix(),
      mainVerse: {
        book: 0,
        startChapter: "",
        startVerse: "",
        endVerse: "",
        endChapter: ""
      },
      scriptureReading: {
        book: 0,
        startChapter: "",
        startVerse: "",
        endVerse: "",
        endChapter: ""
      },
      verseSearch: "",
      otherVerses: [],
      time: "am",
      collection: "none"
    };

    this.state = {
      object: props.new ? clone(this.defaultObject) : clone(this.props.object),
      titleAlert: false,
      verseAlert: false,
      guest: false,
      collections: window.sermon_collections,
      newCollection: false
    };

    this.tags = {};
  }

  componentWillReceiveProps(newProps) {
    if (newProps != this.props) {
      if (newProps.new) {
        this.setState({object: clone(this.defaultObject)});
      } else {
        var guest = false;
        if (knownTeachers.indexOf(newProps.object.teacher) === -1) {
          guest = true;
        }
        this.setState({object: clone(newProps.object), guest: guest});
      }
    }
  }

  dismissAlerts() {
    this.setState({titleAlert: false, verseAlert: false});
  }

  verseIsEmpty(verse) {
    return (!verse.startChapter || verse.startChapter === "") && (!verse.startVerse || verse.startVerse === "") && (!verse.endChapter || verse.endChapter === "") && (!verse.endVerse || verse.endVerse === "");
  }

  saveCheck() {
    let obj = clone(this.state.object);

    return new Promise(function(resolve, reject) {
      let verseCheck = true;
      if (obj.otherVerses) {
        obj.otherVerses.forEach(verse => {
          if(!parseVerse(verse)) verseCheck = false;
        });
      }

      if (obj.title !== "" && verseCheck && (parseVerse(obj.mainVerse) || this.verseIsEmpty(obj.mainVerse)) && (parseVerse(obj.scriptureReading) || this.verseIsEmpty(obj.scriptureReading))) {
        if (this.verseIsEmpty(obj.mainVerse)) {
          obj.mainVerse = null;
        } else {
          obj.mainVerse = parseVerse(obj.mainVerse);
        }

        if (this.verseIsEmpty(obj.scriptureReading)) {
          obj.scriptureReading = null;
        } else {
          obj.scriptureReading = parseVerse(obj.scriptureReading);
        }

        if (obj.otherVerses) {
          obj.otherVerses = obj.otherVerses.map(item => parseVerse(item));
        }

        if (obj.mainVerse) {
          obj.verseSearch = verseHash(obj.mainVerse);
        }

        var pattern = /\d{9}$/;
        if (obj.vimeoURL && obj.vimeoURL !== "" && obj.vimeoURL.match(pattern))
          obj.vimeoID = obj.vimeoURL.match(pattern)[0];


        resolve(obj);
      } else {
        if (obj.title === "") {
          this.setState({titleAlert: true});
          reject();
        } else {
          this.setState({verseAlert: true});
          reject();
        }
      }
    }.bind(this));
  }

  addNewVerse() {
    var sermon = this.state.object;
    if (sermon.otherVerses === undefined) { sermon.otherVerses = []; }
    sermon.otherVerses.push({book: "", startVerse: "", startChapter: "", endVerse: ""});
    this.setState({sermon: sermon});
  }

  removeLastVerse() {
    var sermon = this.state.object;
    sermon.otherVerses.pop();
    this.setState({sermon: sermon});
  }

  updateMainVerse(verse) {
    this.state.object.mainVerse = verse;
  }

  updateScriptureReading(verse) {
    this.state.object.scriptureReading = verse;
  }

  updateOtherVerse(verse, index) {
    this.state.object.otherVerses[index] = verse;
  }

  updateVerse(verse) {
    if (verse === null || (verse.book === "" && verse.startChapter === "" && verse.startVerse === "" && verse.endVerse === "" && verse.endChapter === "")) {
      this.state.object.verse = null;
    }
    else {
      this.state.object.verse = verse
    }
  }

  render() {

    var otherVerseViews = null;
    if (this.state.object.otherVerses !== undefined && this.state.object.otherVerses.length > 0) {
      otherVerseViews = this.state.object.otherVerses.map((verse, i) => {
        return <div key={i}><VerseGroup key={i} title="" verse={verse} id={i} update={this.updateOtherVerse.bind(this)} /><br /></div>
      });
    }

    let tagStyle = {
      width: 100,
      float: 'left',
      marginTop: 8,
      marginRight: 10
    }

    var tagViews = [<div style={tagStyle}><FormControl type="text" placeholder="new..." value="" onChange={e => {
      var object = this.state.object;
      if (!object.tags)
        object.tags = [];
      object.tags.push(e.target.value);
      this.setState({object});
    }} /></div>];
    if (this.state.object.tags !== undefined && this.state.object.tags.length > 0) {
      tagViews = this.state.object.tags.map((tag, i) => {
        return <div style={tagStyle}><FormControl inputRef={ref => this.tags["tag" + i] = ref} type="text" onChange={e => {
          var object = this.state.object;
          if (e.target.value === "") {
            object.tags.splice(i, 1);
            this.tags["tag" + i].blur();
          }
          else
            object.tags[i] = e.target.value;
          this.setState({object});
        }} value={this.state.object.tags[i]} /></div>
      }).concat(tagViews);
    }

    var collections = Object.keys(this.state.collections).sort((a, b) => { // eslint-disable-line no-unused-vars
      if (a === "none") return -1;
      else return 0;
    }).map(key => <option key={key} value={this.state.collections[key].name}>{this.state.collections[key].name}</option>);
    //collections.push(<option value="new">New Collection</option>);

    return (
      <PanelEditView title="Sermon" setState={this.setState.bind(this)} dismissAlerts={this.dismissAlerts.bind(this)} defaultObject={this.defaultObject} saveCheck={this.saveCheck.bind(this)} {...this.props}>

        <FieldGroup id="title" label="Title" placeholder="Enter text" context={this} comp="object" />

        <FormGroup controlId="teacher">
          <ControlLabel>Teacher</ControlLabel>
          <FormControl componentClass="select" onChange={e => {
            let option = e.target.value;
            var obj = this.state.object;
            obj.teacher = option;
            if (option == "Guest Speaker") {
              obj.teacher = "";
              this.setState({object: obj, guest: true});
            } else {
              obj.teacher = option;
              this.setState({object: obj, guest: false});
            }
          }} value={this.state.guest ? "Guest Speaker" : this.state.object.teacher}>
            {knownTeachers.map(item => { return <option key={item} value={item}>{item}</option>; })}
          </FormControl>
        </FormGroup>

        {this.state.guest && <FieldGroup id="teacher" placeholder="Guest Speaker Name" context={this} comp="object" />}

        <FormGroup controlId="date">
          <ControlLabel>Date</ControlLabel><br />
          <Datetime open={true} value={moment.unix(this.state.object.date)} input={false} onChange={function(e) { var obj = this.state.object; obj.date = e.unix(); this.setState({event: obj}); }.bind(this)} timeFormat={false} />
        </FormGroup>
        <Select id="time" label="Time" context={this} comp="object">
          <option value="am">Morning (AM)</option>
          <option value="pm">Evening (PM)</option>
        </Select>

        {this.state.newCollection ?
          <FieldGroup id="collection" label="Collection" placeholder="New Collection Name" context={this} comp="object" />
          :
          <FormGroup controlId="collection">
            <ControlLabel>Collection</ControlLabel>
            <FormControl componentClass="select" onChange={function(e) {
              let option = e.target.value;
              let object = this.state.object;
              Object.keys(this.state.collections).forEach(item => {
                if (this.state.collections[item].name === option) {
                  object.collection = item;
                }
              });
              this.setState({object});
            }.bind(this)} value={this.state.collections[this.state.object.collection] ? this.state.collections[this.state.object.collection].name : "none"}>
              {collections}
            </FormControl>
          </FormGroup>
        }

        <VerseGroup title="Main Scripture (Optional)" main verse={this.state.object.mainVerse} id="mainVerse" update={this.updateMainVerse.bind(this)}/>
        <br />
        <VerseGroup title="Scripture Reading (Optional)" main verse={this.state.object.scriptureReading} id="scriptureReading" update={this.updateScriptureReading.bind(this)}/>
        <br />

        <ControlLabel>Scriptures Referenced</ControlLabel>
        {otherVerseViews}
        <div style={{width: '100%', height: 5}} />
        <p style={{float: 'left'}}><button className="blueButton" onClick={this.addNewVerse.bind(this)}>Add New</button></p>
        {this.state.object.otherVerses !== undefined && this.state.object.otherVerses.length > 0 && <p style={{float: 'left'}}><button className="blueButton" onClick={this.removeLastVerse.bind(this)}>Remove Last</button></p>}
        <div style={{width: '100%', height: 45}} />

        <ControlLabel>Sermon Tags</ControlLabel>
        <div>
          {tagViews}
        </div>
        <br />
        <div style={{width: '100%', height: 45}} />

        <FieldGroup id="vimeoURL" label="Vimeo URL" placeholder="Enter Vimeo Share URL" context={this} comp="object" />
        <FieldGroup id="audioURL" label="Audio URL" placeholder="Enter URL" help="Include http:// • URL must end in .mp3" context={this} comp="object" />
        <FieldGroup id="blogURL" label="Sermon Archive (Weebly) URL" placeholder="Enter URL" help="To find this, tap on the blog post header (sermon title), and then copy the URL from the top of your browser" context={this} comp="object" />

        <CCOAlert in={this.state.titleAlert} type="danger" title="Blank Fields" content="Please enter a Title and select a Teacher" />
        <CCOAlert in={this.state.verseAlert} type="danger" title="Scripture Error" content="Please only enter numbers into the scripture fields, and make sure that you have entered a valid scripture reference for both the Main Scripture and each of the Scripture References"  />

      </PanelEditView>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/sermons/EditSermonView.js
 **/